import React from 'react';
import { Link } from 'react-router-dom'

export default function Press_release(){
  return (
     <div>
     {/* Header Start */}
	  <div className="container-fluid hero-header bg-light py5 mb-5"  style={{"padding-top":"1rem !important","padding-bottom":"1rem !important"}}>
		<div className="container py-5">
		  <div className="row g-5 align-items-center">
			<div className="col-lg-12">
			  <h1 className="display-4 mb3 animated slideInDown">Press Release & Announcement</h1>
			  <nav aria-label="breadcrumb animated slideInDown">
				<ol className="breadcrumb mb-0">
				  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
				  <li className="breadcrumb-item"><Link to="/">Investor Relation</Link></li>
				  <li className="breadcrumb-item active" aria-current="page">Press Release & Announcement</li>
				</ol>
			  </nav>
			</div>
			
			
		  </div>
		</div>
	  </div>
	  {/* Header End */}
	  {/* About Start */}
	  <div className="container-xxl py5">
		<div className="container">
		  <div className="row g-5 align-items-center">
			<div className="table-responsive table_heading">
				 {/* <table className="table table-bordered table-striped">
					<thead>
					  <tr>
						<th width="20" class="text-center">No.</th>
						<th className="text-left">Press Release & Announcement</th>
						<th>Download Link</th>
					  </tr>
					</thead>
					<tbody>
					  <tr>
						<td>Publication 16.11.2025</td>
						<td width={280} className="text-center">
						 <Link to="/Press-Realease-&-Announcement/Publication-16.11.2025.pdf" target="_blank">
							Download
						  </Link>{" "}
						</td>
					  </tr>
					  <tr>
						<td>AGM Notice</td>
						<td width={280} className="text-center">
						 <Link to="/Press-Realease-&-Announcement/AGM-Notice.pdf" target="_blank">
							Download
						  </Link>{" "}
						</td>
					  </tr>  
					</tbody>
				  </table>*/}
				  <table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">2026-27</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
				  <tr>
					  <td>Notice of 41th AGM</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2026-27/Notice-of-41th-AGM.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>FR-BM-10.08.2026</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2026-27/FR-BM-10.08.2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>FR BM-30.05.2026</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2026-27/FR-BM-30.05.2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
				  </tbody>
				 </table>
				  <table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">2025-26</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
				  <tr>
					  <td>FR BM-30.09.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2025-26/FR-BM-30.09.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>FR BM-30.06.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2025-26/FR-BM-30.06.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Notice Of 40th AGM</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2025-26/notice-of-40th-AGM.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  </tbody>
				   <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">2024-25</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
				    <tr>
					  <td>FR BM-31.03.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2024-25/FR-BM-31.03.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>FR BM-31.12.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2024-25/FR-BM-31.12.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>FR BM-30.09.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2024-25/FR-BM-30.09.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>FR BM-30.06.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2024-25/FR-BM-30.06.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Notice Of 39th AGM</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2024-25/notice-of-39th-AGM.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  </tbody>
				   <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">2023-24</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
				    <tr>
					  <td>FR BM-31.03.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2023-24/FR-BM-31.03.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>BR FM-31.12.2023</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2023-24/BR-FM-31.12.2023.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>FR BM-30.09.2023</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2023-24/FR-BM-30.09.2023.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>FR BM-30.06.2023</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2023-24/FR-BM-30.06.2023.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>EGM-12.05.2023</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2023-24/EGM-12.05.2023.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>EGM-24.04.2023</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2023-24/EGM-24.04.2023.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Notice Of 38th AGM</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2023-24/notice-of-38th-AGM.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  </tbody>
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">2022-23</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
				  <tr>
					  <td>FR BM-31.03.2023</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2022-23/FR-BM-31.03.2023.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>FR BM-30.09.2022</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2022-23/FR-BM-30.09.2022.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr> 
					<tr>
					  <td>FR BM-30.06.2022</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2022-23/FR-BM-30.06.2022.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Notice Of 37th AGM</td>
					  <td width={280} className="text-center">
					   <Link to="/Press-Realease-&-Announcement/2022-23/notice-of-37th-AGM.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  </tbody>
				</table>
				</div>

			
		  </div>
		</div>
	  </div>
	  {/* About End */}
	</div>
    );
}